import type React from 'react';

import type { CardId } from '@vlabs/api/point-api/model';
import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import { CopyButton } from '@vlabs/uikit';

import st from './CardIdCell.module.sass';

interface CardIdCellProps {
  cardId?: CardId;
}

function CardIdCell({
  cardId = undefined,
}: CardIdCellProps): React.JSX.Element | null {
  if (!cardId) return null;
  return (
    <div className={st.Value}>
      <div className={st.TextWrapper}>
        <TruncatedText
          hasTruncation
          tooltipContent={cardId}
        >
          {cardId}
          <CopyButton
            className={st.CopyButton}
            round
            value={cardId}
          />
        </TruncatedText>
      </div>
    </div>
  );
}

export { CardIdCell };
